// extracted by mini-css-extract-plugin
module.exports = {"strong":"lx_ly"};